import React, { useEffect, useState } from "react";
import classes from "../css/ActionPage.module.css";
import { toast } from "react-toastify";
import axios from "axios";
import { baseUrl, baseUrlApi, getscriptflow, mobileSubscription, mobileSubscriptionOnDecline, qualification, subscribe as qualifyEndpoint } from "../api/api";
import { Link, useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import { Block } from "@mui/icons-material";
import BlockModal from "../components/BlockModal";
import BlockModalFree from "../components/BlockModalFree";
const HeadersPageNewFree = () => {
  const navigate = useNavigate();

  const [sourceTrxId,setSourceTrxId] = useState('')
  const [tokenId,setTokenId] = useState('')

  const [showBlockModal,setShowBlockModal] = useState(false)

    const params = new URLSearchParams(window.location.search);
    const num = params.get("msisdn");
      const ext_ref = params.get('ext_ref')

      const [msisdn,setMsisdn] = useState(params.get("msisdn"))

      const [evinaLoaded,setEvinaLoaded] = useState(false)
      const [contentBlockStatus,setContentBlockStatus] = useState(null)
      const [contentBlockDecision,setContentBlockDecision] = useState(null)

      const [loadingAccept,setLoadingAccept] = useState(false)

   const [extRef, setExtRef] = useState("");
    const [loading, setLoading] = useState(true);
    const [TVal, setTVal] = useState("");

    const uniqueId = uuidv4();

  const callQualifyAPI = async () => { 
   

    setLoading(true)

    try {
      const payload = { msisdn: msisdn?.trim(),ti:ext_ref || extRef };
      const { data } = await axios.post(`${baseUrlApi}${qualification}`, payload);

       if (data?.status == "success") {
              toast.success(data?.message);
              sessionStorage.setItem("packageId", data?.packageId);
              sessionStorage.setItem("sourceTransactionId", data?.sourceTransactionId);
              localStorage.setItem("ext_ref", extRef);
              
              setSourceTrxId(data?.sourceTransactionId)
              setLoading(false)
              setContentBlockStatus(data?.contentBlockStatus)

              if(data?.contentBlockStatus.toLowerCase() == 'y' || data?.contentBlockStatus.toLowerCase() == 'contentblock'){
                setShowBlockModal(true)
              }
             
            } 
           
          else {
                  // toast.error(data.message || "Something went wrong.");
          
                  if(data.code == '423'){
                    
                    navigate('/block')
                  
                  }
                  else if(data.code == '404'){
                    toast.error(data.message);
                  }
                  else if(data.code == '409'){
          
                    if(data.message.toLowerCase() == 'user already subscribed'){
                      localStorage.setItem('msisdn',msisdn)
                    //   navigate('/home')
                    // window.location.href = `https://vdkicknwin.gameit.in/home?msisdn=${data?.subscriptionId}`

                    navigate(`/home?msisdn=${data?.subscriptionId}`);

                    }
                    else if(data.message.includes('Business Conflict:')){
                      toast.error(data.message);
                    }
                    else if(data.message == 'SYSTEM_ERROR' || data.message.toLowerCase() == 'system error'){
                      navigate('time-out')
                    }
                  }
                  else if(data.code == '400'){
                    //bad request
                    toast.error(data.message)
                  }
                  else if(data.code == '429' || data.code == '401' || data.code == '403' || data.code == '500' || data.code == '429'){
                    toast.error(data.message)
                  }
          
                   
          
                  setMsisdn('')
                }
    } catch (err) {
      console.error("Qualify API failed:", err);

       if(err.response.data.code == '423'){
                navigate('/block')
             
              }
              else if(err.response.data.code == '404'){
                toast.error(err.response.data.message);
      
              }
              else if(err.response.data.code == '409'){
      
                if(err.response.data.message.toLowerCase().includes('user already subscribed')){
                  localStorage.setItem('msisdn',msisdn)
                //   navigate('/home')
                // window.location.href = `https://vdkicknwin.gameit.in/home?msisdn=${msisdn}`
navigate(`/home?msisdn=${msisdn}`);
                }
                else if(err.response.data.message.includes('Business Conflict:')){
                  toast.error(err.response.data.message);
                }
                else if(err.response.data.message == 'SYSTEM_ERROR' || err.response.data.message.toLowerCase() == 'system error'){
                  navigate('time-out')
                }
              }
              else if(err.response.data.code == '400'){
                //bad request
                toast.error(err.response.data.message)
              }
              else if(err.response.data.code == '429' || err.response.data.code == '401' || err.response.data.code == '403' || err.response.data.code == '500' || err.response.data.code == '429'){
                toast.error(err.response.data.message)
              }
              else{
                navigate('/')
              }
      


      toast.error("Qualify request failed.");




      
    }
  };


  const handleAcceptBlock=()=>{
    console.log('onaccept called')
    setContentBlockDecision('Accepted')
    // setShowModal(true)
    setShowBlockModal(false);
  }

  const handleDeclineBlock=()=>{
    console.log('onreject called')

    // setContentBlockDecision('Rejected')
    // setShowModal(true)
    
      handleMobileSubscription('Rejected')
   


    window.location.href = 'https://www.vodacom.co.za/vodacom/shopping/v/add-to-bill';
  return;



    
    // setShowBlockModal(false);
    
  }





useEffect(() => {
  let existingToken = sessionStorage.getItem("tokenId");
 
  handleAccept()
}, []);




 
  const handleAccept = async () => {

     try {
    const url = `${baseUrlApi}${getscriptflow}?txnId=${ext_ref || uniqueId}`;
    const { data } = await axios.get(url);
    console.log(data,'---data---')
   
    const parsed = JSON.parse(data.response); 
    const scriptContent = parsed.s;
    const t = parsed.t;
    const ti = data.ti;

    console.log(t,'--t----');
    setTokenId(t)
    console.log(ti,'=======ti=======');
    console.log(scriptContent,'=====sc======')

   
    setExtRef(ti);

    if (scriptContent) {
      const top_head = document.head;
      const anti_script = document.createElement("script");
      anti_script.innerHTML = scriptContent;
      top_head.insertBefore(anti_script, top_head.firstChild);

      document.dispatchEvent(new Event("DCBProtectRun"));
      document.addEventListener("gateway-load", (evt) => {
        console.log("Anti‑fraud gateway loaded:", evt);
        setEvinaLoaded(true)
      });
    }
  } catch (error) {
    console.error("Error fetching script‑flow:", error);
    toast.error("Could not load verification script.");
  } finally {
    // setLoading(false);
  }
  };

  const handleDecline = () => {
    // navigate("/subscribe", { replace: true });

    console.log('rejecteess-------------')

    handleMobileSubscription('Rejected')

    window.location.href = 'https://www.vodacom.co.za/vodacom/shopping/v/add-to-bill';
  return;

//     setTimeout(()=>{

//    navigate("/subscribe", { replace: true })
//  },3000)
  };

  const handleMobileSubscription = async (decision) => {

    console.log('on accept called-----------------------')
  const extRef = localStorage.getItem("ext_ref");

  const packageId = sessionStorage.getItem("packageId");
  setLoadingAccept(true)

  console.log(extRef,'--extref---');
  console.log(msisdn,'--msisdn---');
  console.log(tokenId,'--token---');
  console.log(packageId,'------packageid-----')

  if(!decision){
    decision = 'rejected'
  }
  
  try {
    const payload = {
      // txnId: extRef,
      msisdn,
      tokenId:sourceTrxId,
      sourceTransactionId:sourceTrxId,
      packageId,
      contentBlockStatus:contentBlockStatus,
      contentBlockDecision:decision
    };


    const res = await axios.post(`${baseUrlApi}${mobileSubscription}`, payload);

    // You can still re-save values if needed
    const responseData = await res.data;
    console.log("Mobile Subscription Response:", responseData);

    setLoadingAccept(false)

    console.log(res.data.msisdn)


    if(res.data.code == 200){
    //   navigate('/home')
    // window.location.href = `https://vdkicknwin.gameit.in/home?msisdn=${res?.data?.subscriptionId}`

    navigate(`/home?msisdn=${res?.data?.subscriptionId}`);

    }


      else {
          
           if(responseData.code == 400){
           
                   if(responseData.message == 'Invalid OTP. Please enter the correct OTP.'){
                     toast.error(responseData.message)
                     return;
                   }
                   else if(responseData.message == 'OTP expired. Press re-send OTP or start over again from MSISDN page.'){
           
                      toast.error(responseData.message)
           
                    
                     return;
           
                   }
                   else if(responseData.message == 'Either press re-send OTP or start over again from MSISDN page.'){
                     toast.error(responseData.message)
                   }
                   else if(responseData.message.includes('Maximum retry limit exceeded. Locked for 24 hours')){
                     toast.error(responseData.message)
                     navigate('/time-out')
                   }
           
                   else{
                     toast.error(responseData.message)
                     navigate('/time-out')
                   }
                   
                  }
                  else if(responseData.code == 409){
                    if(responseData.message.toLowerCase() == 'user already subscribed'){
                       localStorage.setItem('msisdn',res?.data?.subscriptionId)
                    //    navigate('/home')
                    //  window.location.href = `https://vdkicknwin.gameit.in/home?msisdn=${msisdn}`

                    navigate(`/home?msisdn=${res?.data?.subscriptionId}`);
                     }
                     else if(responseData.message.includes('Business Conflict:')){
                       toast.error(responseData.message);
                        toast.error('A system error occurred and we could not complete the transaction.')
                       navigate('/subscribe')
                     }
                     else if(responseData.message == 'SYSTEM_ERROR' || responseData.message.toLowerCase() == 'system_error' || responseData.message.toLowerCase().includes('system_error')){
                        toast.error('A system error occurred and we could not complete the transaction.')
                       navigate('/subscribe')
                     }
                     else if(responseData.message == 'Fraud detected by EVINA or page compliance failed.'){
                       
                        toast.error('A system error occurred and we could not complete the transaction.')
                       navigate('/subscribe')
           
                     }
                     else if(responseData.message.includes('Insufficient') || responseData.message.includes('Payment failed')){
                       navigate('/insufficient-funds')
                     }
                    
                     else if(responseData.message == 'Business rule violation: system_error'){
                        toast.error('A system error occurred and we could not complete the transaction.')
                        navigate('/subscribe')
                     }
                     else{
           
                     }
                  }
                  else if(responseData.code == '423'){
                     navigate('/block')
                   
                   }
           
                   else if(responseData.code == '429' || responseData.code == '500'){
                     //toast.error(data.message)
                     // navigate('/time-out')
                      toast.error('A system error occurred and we could not complete the transaction.')
                       navigate('/subscribe')
                   } 
                    else{
                    
                     toast.error(responseData.message)
                    }
           
           
          }
  } catch (err) {
    console.error("Mobile Subscription failed:", err);
    setLoadingAccept(false)

     if(err.response.data.code == '409'){
             toast.error(err.response.data.message);
             if(err.response.data.message.includes('Insufficient')){
              navigate('/insufficient-funds')
             }
             else if(err.response.data.message == 'System error' || err.response.data.message == 'Session expired. Please start again.'){
               toast.error('A system error occurred and we could not complete the transaction.')
                navigate('/subscribe')
             }
             else if(err.response.data.message == 'Restricted Customer Profile. Content Blocked'){
              navigate('/block')
             }
             else{
              navigate('/')
             }
    
          }



    toast.error("Subscription failed. Please try again.");
  }
};



useEffect(()=>{
    if(evinaLoaded){
        callQualifyAPI()
    }
    
},[evinaLoaded])




 const handleMobileSubscriptionOnDecline = async (decision) => {

    console.log('on accept called-----------------------')
  const extRef = localStorage.getItem("ext_ref");

  const packageId = sessionStorage.getItem("packageId");
  setLoadingAccept(true)

  console.log(extRef,'--extref---');
  console.log(msisdn,'--msisdn---');
  console.log(tokenId,'--token---');
  console.log(packageId,'------packageid-----')

  // if(!decision){
  //   decision = 'rejected'
  // }
  
  try {
    const payload = {
      // txnId: extRef,
      msisdn,
      tokenId:sourceTrxId,
      sourceTransactionId:sourceTrxId,
      packageId,
      contentBlockStatus:contentBlockStatus,
      contentBlockDecision:decision
    };


    const res = await axios.post(`${baseUrlApi}${mobileSubscriptionOnDecline}`, payload);

    // You can still re-save values if needed
    const responseData = await res.data;
    console.log("Mobile Subscription Response:", responseData);

    setLoadingAccept(false)

    console.log(res.data.msisdn)


    if(res.data.code == 200){
    //   navigate('/home')
    // window.location.href = `https://vdkicknwin.gameit.in/home?msisdn=${res?.data?.subscriptionId}`

    navigate(`/home?msisdn=${res?.data?.subscriptionId}`);

    }


      else {
          
           if(responseData.code == 400){
           
                   if(responseData.message == 'Invalid OTP. Please enter the correct OTP.'){
                     toast.error(responseData.message)
                     return;
                   }
                   else if(responseData.message == 'OTP expired. Press re-send OTP or start over again from MSISDN page.'){
           
                      toast.error(responseData.message)
           
                    
                     return;
           
                   }
                   else if(responseData.message == 'Either press re-send OTP or start over again from MSISDN page.'){
                     toast.error(responseData.message)
                   }
                   else if(responseData.message.includes('Maximum retry limit exceeded. Locked for 24 hours')){
                     toast.error(responseData.message)
                     navigate('/time-out')
                   }
           
                   else{
                     toast.error(responseData.message)
                     navigate('/time-out')
                   }
                   
                  }
                  else if(responseData.code == 409){
                    if(responseData.message.toLowerCase() == 'user already subscribed'){
                       localStorage.setItem('msisdn',res?.data?.subscriptionId)
                    //    navigate('/home')
                    //  window.location.href = `https://vdkicknwin.gameit.in/home?msisdn=${msisdn}`

                    navigate(`/home?msisdn=${res?.data?.subscriptionId}`);
                     }
                     else if(responseData.message.includes('Business Conflict:')){
                       toast.error(responseData.message);
                        toast.error('A system error occurred and we could not complete the transaction.')
                       navigate('/subscribe')
                     }
                     else if(responseData.message == 'SYSTEM_ERROR' || responseData.message.toLowerCase() == 'system_error' || responseData.message.toLowerCase().includes('system_error')){
                        toast.error('A system error occurred and we could not complete the transaction.')
                       navigate('/subscribe')
                     }
                     else if(responseData.message == 'Fraud detected by EVINA or page compliance failed.'){
                       
                        toast.error('A system error occurred and we could not complete the transaction.')
                       navigate('/subscribe')
           
                     }
                     else if(responseData.message.includes('Insufficient') || responseData.message.includes('Payment failed')){
                       navigate('/insufficient-funds')
                     }
                    
                     else if(responseData.message == 'Business rule violation: system_error'){
                        toast.error('A system error occurred and we could not complete the transaction.')
                        navigate('/subscribe')
                     }
                     else{
           
                     }
                  }
                  else if(responseData.code == '423'){
                     navigate('/block')
                   
                   }
           
                   else if(responseData.code == '429' || responseData.code == '500'){
                     //toast.error(data.message)
                     // navigate('/time-out')
                      toast.error('A system error occurred and we could not complete the transaction.')
                       navigate('/subscribe')
                   } 
                    else{
                    
                     toast.error(responseData.message)
                    }
           
           
          }
  } catch (err) {
    console.error("Mobile Subscription failed:", err);
    setLoadingAccept(false)

     if(err.response.data.code == '409'){
             toast.error(err.response.data.message);
             if(err.response.data.message.includes('Insufficient')){
              navigate('/insufficient-funds')
             }
             else if(err.response.data.message == 'System error' || err.response.data.message == 'Session expired. Please start again.'){
               toast.error('A system error occurred and we could not complete the transaction.')
                navigate('/subscribe')
             }
             else if(err.response.data.message == 'Restricted Customer Profile. Content Blocked'){
              navigate('/block')
             }
             else{
              navigate('/')
             }
    
          }



    toast.error("Subscription failed. Please try again.");
  }
};


const handleDeclineButton = ()=>{
  // setOtpPage(false)

  handleMobileSubscriptionOnDecline('Rejected')
  window.location.href = 'https://www.vodacom.co.za/vodacom/shopping/v/add-to-bill';
  return;
}



  return (
    <div className={`cptpl_page ${classes.wrapper}`}>
   <input type="hidden" value="20221206" name="cptpl_template" class="cptpl_template"/>
   {/* <input type="hidden" value="20251023" name="cptpl_template" class="test cptpl_template" />  */}

      <input type="hidden" value="" name="cptpl_landing_page_id" class="test  cptpl_landing_page_id  " />

      <div className={classes.card}>

       <div className={classes.logoHeading}>
            <img src="https://vd-kickwin.gameit.in/assets/images/soccer-ball.png" alt="Logo" className={`cptpl_logo cptpl_logo_static ${classes.logo}`}
           crossorigin="anonymous" />
            <h3 className={`cptpl_service ${classes.heading}`}>Kick n Winn</h3>
          </div>

        <p className={classes.description}>
       
      <span> Get Endless Sports Insights with Kick n Winn</span><br/>
      {/* <span className="cptpl_price" > R9/Day</span> */}
            <span className="cptpl_price" >Enjoy Your First-Day Free Trial at R7/Day After Trial</span>

      <span className="cptpl_account" > on Your Vodacom Account</span>
      <br/>
      <span className="cptpl_bill" >Pay with Vodacom Add to Bill</span>
         <br/>
          <br/>
         
         <span>
                       <Link className={` cptpl_terms ${classes.terms}`}>Terms & Conditions</Link>

           {/* <Link to='/terms' className={` cptpl_terms ${classes.terms}`}>Terms & Conditions</Link> */}
          {/* &nbsp;apply */}
         </span>
        </p>

       <div className={classes.btns} >
         <button onClick={()=>handleMobileSubscription('Accepted')} className={`protected cptpl_subscribe ${classes.accept}  ${loading && 'opacity-20'} bg-gray-400 `} disabled={loading} >{!loadingAccept ? 'ACCEPT':'ACCEPTING'}</button>
        {/* bg-gray-400 */}
      
         <button onClick={handleDeclineButton} disabled={loading} className={`protected cptpl_exit ${classes.decline}  ${loading && 'opacity-20 pointer-events-none' }`  }>DECLINE</button>

       
       </div>
      </div>


    

      {showBlockModal && (

        <BlockModalFree
          onAccept={handleAcceptBlock}
            onDecline={handleDeclineBlock}
        />


       
      )}
    </div>
  );
};

export default HeadersPageNewFree;
